// extracted by mini-css-extract-plugin
module.exports = {"input":"Editable-styles_input__1teRH","rendered":"Editable-styles_rendered__g6yOz","strikethrough":"Editable-styles_strikethrough__2Zcl8"};